import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface VersionComparisonState {
  selectedVersions: Record<string, string[]>; // agentId -> array of selected version IDs
}

const initialState: VersionComparisonState = {
  selectedVersions: {},
};

const versionComparisonSlice = createSlice({
  name: 'versionComparison',
  initialState,
  reducers: {
    toggleVersionSelection: (
      state,
      action: PayloadAction<{ agentId: string; versionId: string }>
    ) => {
      const { agentId, versionId } = action.payload;

      if (!state.selectedVersions[agentId]) {
        state.selectedVersions[agentId] = [];
      }

      const currentSelections = state.selectedVersions[agentId];
      const isSelected = currentSelections.includes(versionId);

      if (isSelected) {
        // Remove from selection
        state.selectedVersions[agentId] = currentSelections.filter(
          id => id !== versionId
        );
      } else if (currentSelections.length < 2) {
        // Add to selection if less than 2 are selected
        state.selectedVersions[agentId] = [...currentSelections, versionId];
      } else {
        // Replace the first selected version with the new one (keep last 2)
        state.selectedVersions[agentId] = [currentSelections[1], versionId];
      }
    },

    clearVersionSelection: (
      state,
      action: PayloadAction<{ agentId: string }>
    ) => {
      const { agentId } = action.payload;
      if (state.selectedVersions[agentId]) {
        state.selectedVersions[agentId] = [];
      }
    },

    setVersionSelection: (
      state,
      action: PayloadAction<{ agentId: string; versionIds: string[] }>
    ) => {
      const { agentId, versionIds } = action.payload;
      state.selectedVersions[agentId] = versionIds.slice(0, 2); // Limit to 2 versions
    },

    clearAllSelections: state => {
      state.selectedVersions = {};
    },
  },
});

export const {
  toggleVersionSelection,
  clearVersionSelection,
  setVersionSelection,
  clearAllSelections,
} = versionComparisonSlice.actions;

export default versionComparisonSlice.reducer;
